import React, { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import { Link } from "react-router-dom";

export const HeroHome = () => {
    const [sliders, setSliders] = useState([]);

    useEffect(() => {
        fetch("/getSliders")
            .then(res => res.json())
            .then(result => {
                if (result?.estado === 0) setSliders([]);
                else {
                    setSliders(result);
                    new Glide(".glide", {
                        gap: 0,
                        animationDuration: 300,
                        type: "carousel",
                        autoplay: 5000,
                        hoverpause: false,
                        perView: 1,
                        bound: true
                    }).mount();
                }
            });
    }, []);

    if (!sliders.length)
        return (
            <div className="d-flex flex-column w-100 justify-content-center align-items-center">
                <p className="mt-2">Actualizando Sliders</p>
                <div
                    className="spinner-border text-rojo mb-half"
                    role="status"
                >
                </div>
            </div>
        );
    return (
        <div className="heroHome">
            <div className="glide sliderHome">
                <div className="glide__track" data-glide-el="track">
                    <ul className="glide__slides mb-0">
                        {sliders.map(slide => (
                            <li
                                className="glide__slide heroHome--slide3"
                                key={slide.id}
                            >
                                <img
                                    className="heroHome--imgDesktop heroHome--imgDesktop_auto"
                                    src={`/storage/sliders/${slide.id}/${slide.hash_foto}`}
                                />
                                <img
                                    className="heroHome--imgMobile"
                                    src={`/storage/sliders/${slide.id}/${slide.hash_foto_mobile}`}
                                />
                                {slide.texto_boton && (slide.link || slide.legales_titulo) && //Back no debiera enviar nada en texto_boton
                                    <div className="heroHome--div">
                                        <a
                                            className="btn-heroHome"
                                            target={slide.link ? "_blank" : "_self"}
                                            href={
                                                slide.link
                                                    ? slide.link
                                                    : `/legales/${slide.id}`
                                            }
                                        >
                                            <div
                                                className="home_suscripcion"
                                                // style={{
                                                //     backgroundColor: "#ffb80f"
                                                // }}
                                            >
                                                <small>{slide.texto_boton}</small>
                                                <img
                                                    className="ml-half"
                                                    src="/images/icons/small.svg"
                                                />
                                            </div>
                                        </a>
                                    </div>
                                }

                                {/* <a
                                    className="boton_corregido_slider"
                                    target={slide.link ? "_blank" : "_self"}
                                    href={
                                        slide.link
                                            ? slide.link
                                            : `/legales/${slide.id}`
                                    }
                                >
                                    <button className="hero mt-half">
                                        {slide.texto_boton}
                                        <img
                                            className="ml-half"
                                            src="/images/icons/small.svg"
                                        />
                                    </button>
                                </a> */}
                            </li>
                        ))}
                    </ul>
                </div>
                <div
                    className="glide__bullets--down"
                    data-glide-el="controls[nav]"
                >
                    {sliders.map((_, index) => (
                        <button
                            className="glide__bullet glide__bullet--left"
                            data-glide-dir={`=${index}`}
                            key={_.id}
                        ></button>
                    ))}
                </div>
            </div>
        </div>
    );
};
